import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'search',
    standalone: true,
})
export class SearchPipe implements PipeTransform {
    transform(value: any, input: string, field?: string) {
        if (input) {
            input = input.toLowerCase();
            if (field) {
              return value.filter((el: any) => {
                if(!el[field]) return false
                return el[field].toString().toLowerCase().indexOf(input) > -1;
            });
            }
            else {
              return value.filter((el: any) => {
                if(!el) return false;
                return el.toString().toLowerCase().indexOf(input) > -1;
            });
            }

        }
        return value;
    }
}
